import { useQuery } from '@apollo/client/react';
import { ACCESS_REVIEWERS } from '../../../lib/access';
import type { AccessReviewer } from '../../../lib/access';
import './ReviewerRoster.css';

/**
 * Live slot for docs/request-access.md (`<!-- docs:live component="ReviewerRoster" -->`):
 * the default access assignees today, as one flat list.
 *
 * Data only. It reads the same `accessReviewers` query as Settings → Default access assignees,
 * so a person added or removed there shows here with no doc edit. Who decides, and when, is
 * prose and lives in the markdown.
 * Contract: .claude/skills/docs-writer/references/mapping.md §8.
 */
export function ReviewerRoster() {
  const { data, loading, error } = useQuery<{ accessReviewers: AccessReviewer[] }>(ACCESS_REVIEWERS);

  if (error) {
    return (
      <p className="doc-roster-state" role="alert">
        Couldn&rsquo;t load the default access assignees.
      </p>
    );
  }
  if (!data && loading) return <p className="doc-roster-state">Loading the default access assignees…</p>;

  const people = data?.accessReviewers ?? [];
  if (people.length === 0) return <p className="doc-roster-state">No default access assignees are configured yet.</p>;

  return (
    <div className="doc-roster">
      <ul className="doc-roster-people">
        {people.map((r) => (
          <li key={r.id}>
            {r.email}
            {r.displayName && <span className="doc-roster-name">{r.displayName}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
